import "./aboutcontent.css";

import React from 'react'
import { Link } from "react-router-dom";
import React1 from "../../assets/8.jpg";
import React2 from "../../assets/1.jpg";

const AboutContent = () => {
  return (
    <div className="about">
    <div className ="left">
    <h1>Who Am I ?</h1>

    <p>I am Hritik Shukla and i have done my btech in computer science from jbit , deradun
    i am a react developer  </p>

    <Link to ="/contact">
        <button className="btn">Contact</button>
    </Link>

    </div>  

    <div className="right">
        <div className="img-container">

        <div className="img-stack top">
            <img src={React1} className ="img" alt ="true"/>
        </div>

        <div className="img-stack bottom">
            <img src={React2} className ="img" alt ="true"/>
        </div>
        </div>
    </div>
    
    </div>
  )
}

export default AboutContent